import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell, RightCell } from 'components/HonestTable/HonestTable.styled'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Pagination } from 'components/Pagination/Pagination'
import {
  clearFatigueOverrides,
  getFatigueOverrides,
  getSingleFatigueOverride,
} from 'features/operations/fatigueSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { Button, Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText } from 'styling/Typography'
import { IGetAllFatigueOverridesSingleResponse } from 'types/api/operationsFatigueApi.interface'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { FatigueOverrideModal } from './FatigueOverrideModal'

const formatUserName = (user: { firstName: string; lastName: string }) =>
  `${user.firstName} ${user.lastName}`

const columns: IHonestTableColumn<IGetAllFatigueOverridesSingleResponse>[] = [
  {
    id: 'worker',
    header: 'Worker',
    sticky: true,
    minWidth: '12rem',
    cell: (item) => (
      <Cell style={{ minHeight: 'auto' }}>
        <BodyText weight='600'>{formatUserName(item.user)}</BodyText>
      </Cell>
    ),
  },
  {
    id: 'approvedBy',
    header: 'Approved by',
    fill: true,
    cell: (item) => <BodyText>{formatUserName(item.approvedByUser)}</BodyText>,
  },
  {
    id: 'reason',
    header: 'Reason',
    fill: true,
    cell: (item) => <BodyText>{item.reason}</BodyText>,
  },
  {
    id: 'validUntil',
    header: 'Valid until',
    align: 'right',
    minWidth: '10rem',
    cell: (item) => (
      <RightCell>
        <BodyText>{formatDateForDisplay(item.validUntil)}</BodyText>
      </RightCell>
    ),
  },
  {
    id: 'createdAt',
    header: 'Created',
    align: 'right',
    minWidth: '10rem',
    cell: (item) => (
      <RightCell>
        <OtherText grey>{formatDateForDisplay(item.createdAt)}</OtherText>
      </RightCell>
    ),
  },
]

export const Fatigue = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
  const [modalOpen, setModalOpen] = useState(false)
  const { data, totalPages } = useSelector((state: RootState) => state.fatigue.overrides)

  useQueryPagination({
    fetchFunctions: [getFatigueOverrides],
    cleanUpFunctions: [clearFatigueOverrides],
    params,
  })

  const handleRowClick = (item: IGetAllFatigueOverridesSingleResponse) => {
    dispatch(getSingleFatigueOverride(item.id.toString()))
  }

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between width='100%' mb='16'>
          <H1WithBack title='Fatigue' arrow />
          <Flex gap='1rem' >
            <Button orange onClick={() => navigate('rules')}>
              Rules
            </Button>
            <Button orange onClick={() => setModalOpen(true)}>
              Add Override
            </Button>
          </Flex>
        </Flex>

        {data?.length ? (
          <HonestTable
            columns={columns}
            data={data}
            keyField='id'
            onClick={handleRowClick}
          />
        ) : (
          <NoData text='No fatigue overrides to display' />
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 30)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
      {modalOpen && <FatigueOverrideModal closeModal={() => setModalOpen(false)} />}
    </>
  )
}
